import * as HeatmapActions from './heatmap.actions';
import type { HeatmapState } from './heatmap.models';

const { HeatmapActionsTypes } = HeatmapActions;

type HeatmapActionsFunctions = Omit<typeof HeatmapActions, 'HeatmapActionsTypes'>;
type ActionsResponses = ReturnType<HeatmapActionsFunctions[keyof HeatmapActionsFunctions]>;

const initialState: HeatmapState = {
  loadingHeatmap: false,
  currentHeatmap: undefined,
  heatmaps: undefined,
  colorization: 'LINEAR'
};

export default (state: HeatmapState = initialState, action: ActionsResponses): HeatmapState => {
  switch (action.type) {
    case HeatmapActionsTypes.LOAD_HEATMAPS:
    case HeatmapActionsTypes.SET_HEATMAP_LOADING:
      return {
        ...state,
        loadingHeatmap: action.payload.indicator ? action.payload.indicator.id : action.payload.phenomenon.id
      };

    case HeatmapActionsTypes.LOAD_HEATMAPS_SUCCESS:
      if (state.loadingHeatmap) {
        return {
          ...state,
          loadingHeatmap: false,
          currentHeatmap: action.payload.currentHeatmap,
          heatmaps: action.payload.heatmaps
        };
      }
      return state;

    case HeatmapActionsTypes.SET_HEATMAP_IDLE:
      return {
        ...state,
        loadingHeatmap: false
      };

    case HeatmapActionsTypes.SET_HEATMAP_COLORIZATION:
      return {
        ...state,
        colorization: action.payload
      };

    case HeatmapActionsTypes.APPLY_HEATMAP_RASTER:
      return {
        ...state,
        loadingHeatmap: false,
        currentHeatmap: action.payload.currentHeatmap,
        heatmaps: {
          ...state.heatmaps,
          [action.payload.areaId]: action.payload.url
        }
      };

    case HeatmapActionsTypes.LOAD_HEATMAPS_FAILURE:
    case HeatmapActionsTypes.CLEAR_HEATMAPS:
      return {
        ...initialState,
        colorization: state.colorization
      };

    default:
      return state;
  }
};
